import { render } from "./AgnosticFilter.vue?vue&type=template&id=54963e49"
import script from "./AgnosticFilter.vue?vue&type=script&lang=js"
export * from "./AgnosticFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__